import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00099 11.2004C7.53432 11.2004 7.06766 11.0204 6.71432 10.6671L2.36766 6.32042C2.17432 6.12708 2.17432 5.80708 2.36766 5.61375C2.56099 5.42042 2.88099 5.42042 3.07432 5.61375L7.42099 9.96042C7.74099 10.2804 8.26099 10.2804 8.58099 9.96042L12.9277 5.61375C13.121 5.42042 13.441 5.42042 13.6343 5.61375C13.8277 5.80708 13.8277 6.12708 13.6343 6.32042L9.28766 10.6671C8.93432 11.0204 8.46766 11.2004 8.00099 11.2004Z",
		fill: "#787878"
	})
});
export default SvgArrowDown;
